export default __webpack_public_path__ + "static/video_bg-b8a3cc37cb45f9c0d14b071d09603973.jpg";